import React from 'react';

const ITEMS = [
  'React Native',
  'React.js',
  'Next.js',
  'TypeScript',
  'Mobile First',
  'iOS · Android',
  'Performance',
  'Clean Code',
  'UI / UX',
  'Available for hire',
];

const Marquee = () => {
  // duplicate the list so the scroll loop is seamless
  const doubled = [...ITEMS, ...ITEMS];

  return (
    <div className="marquee" aria-hidden="true">
      <div className="marquee-track">
        {doubled.map((item, i) => (
          <span key={i} className="marquee-item">
            <span className="marquee-dot" />
            {item}
          </span>
        ))}
      </div>
    </div>
  );
};

export default Marquee;
